import { defineAsyncComponent } from 'vue'
export default {
  bare: defineAsyncComponent(() => import("/opt/simploshop/themes/demo/app/layouts/bare.vue").then(m => m.default || m)),
  "c-root": defineAsyncComponent(() => import("/opt/simploshop/themes/demo/app/layouts/c-root.vue").then(m => m.default || m)),
  cart: defineAsyncComponent(() => import("/opt/simploshop/themes/demo/app/layouts/cart.vue").then(m => m.default || m)),
  customer: defineAsyncComponent(() => import("/opt/simploshop/themes/demo/app/layouts/customer.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/simploshop/themes/demo/app/layouts/default.vue").then(m => m.default || m))
}